module.exports = __webpack_public_path__ + "static/media/Icons-7.d30bf02d.svg";